// @ts-nocheck

/**
 * * `not_started` - not_started
 * `generating` - generating
 * `completed` - completed
 * `failed` - failed
 */
export type ReferenceSheetStatusEnum =
  typeof ReferenceSheetStatusEnum[keyof typeof ReferenceSheetStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferenceSheetStatusEnum = {
  not_started: "not_started",
  generating: "generating",
  completed: "completed",
  failed: "failed",
} as const;
